import React from 'react';

/**
 * Compact form section: title + divider line + content (replaces PrimeReact Fieldset).
 */
export default function FormSection({title, children, className = ''}) {
    const sectionClass = ['settings-page__form-section', className].filter(Boolean).join(' ');
    const plainTitle = typeof title === 'string' || typeof title === 'number';
    return (
        <section className={sectionClass}>
            {title != null && title !== '' && (
                plainTitle ? (
                    <h3 className="settings-page__form-section-title">{title}</h3>
                ) : (
                    <div className="settings-page__form-section-title settings-page__form-section-title--custom">
                        {title}
                    </div>
                )
            )}
            <div className="settings-page__form-section-body">{children}</div>
        </section>
    );
}
